import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FiatWallet } from "@models";

@Component({
	selector: "app-withdraw-unavailable-modal",
	templateUrl: "./withdraw-unavailable-modal.component.html",
	styleUrls: ["./withdraw-unavailable-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class WithdrawUnavailableModalComponent {
	@Input() public wallet: FiatWallet;
	@Input() public fiatName: string;

	@Output()
	public makeDeposit: EventEmitter<void> = new EventEmitter();

	public deposit(): void {
		this.makeDeposit.emit();
	}
}
